import React from 'react';
import { Grid } from '@mui/material';

const DataCardLoader = ({ className }: any) => {
  return (
    <Grid
      container
      rowSpacing={2}
      columnSpacing={5}
      className={className ? className : ''}
      sx={{ marginTop: '10px' }}
    >
      <Grid item md={6} xs={12}>
        <div className="data-card-loader">
          <div className="img"></div>
          <div className="self-center">
            <p></p>
            <p className="sm"></p>
            <p className="xs"></p>
          </div>
        </div>
      </Grid>
      <Grid item md={6} xs={12}>
        <div className="data-card-loader">
          <div className="img"></div>
          <div className="self-center">
            <p></p>
            <p className="sm"></p>
            <p className="xs"></p>
          </div>
        </div>
      </Grid>
      <Grid item md={6} xs={12}>
        <div className="data-card-loader">
          <div className="img"></div>
          <div className="self-center">
            <p></p>
            <p className="sm"></p>
            <p className="xs"></p>
          </div>
        </div>
      </Grid>
      <Grid item md={6} xs={12}>
        <div className="data-card-loader">
          <div className="img"></div>
          <div className="self-center">
            <p></p>
            <p className="sm"></p>
            <p className="xs"></p>
          </div>
        </div>
      </Grid>
    </Grid>
  );
};

export default DataCardLoader;
